<template>
  <section v-if="availableSlotsCount > 0 && !draft">
    <template v-if="peopleInterested">
      <i class="icon icon-view-1"></i>
      <div class="title">{{ t('interested', { count: viewerCount }) }}</div>
      <div class="body">
        {{ itinerary.spotsLeftMessage ?? `Looks like this trip is getting views. Secure your spot now!` }}
      </div>
    </template>

    <template v-else>
      <i class="icon icon-trends-hot-flame"></i>
      <div class="title">{{ t('spots_left', { count: availableSlotsCount }) }}</div>
      <div class="body">
        {{
          itinerary.spotsLeftMessage ??
          `This trip is getting booked faster than expected. Secure your spot before it’s sold out!`
        }}
      </div>
    </template>
  </section>
</template>

<script setup>
import { useItineraryStore } from '@/stores/itinerary.js'
import { computed } from 'vue'
import { divide, randomIntBetween } from '@/utils/numberUtils.js'
import { useShared } from '@/helpers/vueHelpers.js'

const { t } = useShared()
const {
  data: { itinerary, draft, availableSlotsCount, totalComingEventsMaxGuestCount },
} = useItineraryStore()

const peopleInterested = computed(() => divide(availableSlotsCount, totalComingEventsMaxGuestCount, 1) >= 0.3)
const viewerCount = computed(() => (peopleInterested.value ? randomIntBetween(10, 20) : availableSlotsCount))
</script>

<style lang="scss" scoped>
section {
  padding: 32px;
  border-radius: 15px;
  background: $brand-tertiary-light;
  display: grid;
  grid-template-columns: auto 1fr;
  row-gap: 8px;
  column-gap: 12px;
}

.icon {
  font-size: 24px;
}

.title {
  font-size: 18px;
  font-weight: 600;
  line-height: 22px; /* 122.222% */
}

.body {
  grid-column: 2;
}
</style>

<i18n lang="yaml">
en:
  interested: '{count} person interested | {count} people are interested'
  spots_left: 'Sold out | {count} spot left | {count} spots left'
</i18n>
